export default __webpack_public_path__ + "static/media/icon-down.924484c2.svg";